<template>
  <div id="vs4Preview" class="vs4-preview" v-drag @click.stop>
    <div class="vs4-top">
      <span class="title float-left not-select">{{title}}</span>
      <i class="iconfont iconclose float-right" @click.stop="_vs4Close('close')"></i>
    </div>
    <div
      class="vs4-content"
      v-loading="loading"
      element-loading-text="视频正在跑步加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
      >
      <h5-video
        v-if="videoInfo && videoInfo.resourceId"
        class="h5-video"
        ref="videoWrapper"
        :isTrailer="videoInfo.isTrailer"
        :trailerDuration="videoInfo.trailerDuration"
        :resourceId="videoInfo.resourceId"
        :videoUrl="videoInfo.videoUrl"
        :coverUrl="videoInfo.coverUrl"
        :enValue="videoInfo.enValue"
        :zhValue="videoInfo.zhValue"
        :enAndzhValue="videoInfo.enAndzhValue"
        :tValue="videoInfo.tValue"
        :hadLogo="videoInfo.hadLogo"
        :level="videoInfo.level ? videoInfo.level : (videoInfo.levelId ? videoInfo.levelId: 0)"
        :subject="videoInfo.subject ? videoInfo.subject : (videoInfo.subjectId ? videoInfo.subjectId: 0)"
        :fromPopUp="true"
        :needStatistics="needStatistics"
      ></h5-video>
      <p v-if="!loading && resCode" class="p-error">资源获取失败！</p>
      <p v-else-if="!loading && !resCode && !dataList.length" class="p-error">暂无数据！</p>
    </div>
    <div class="vs4-bottom">
      <div v-if="dataList.length" class="current-page">{{selectIndex + 1}}/{{dataList.length}}</div>
      <div v-if="dataList.length" class="mini-list-box">
        <div
          v-if="miniArrow"
          class="mini-pre-btn"
          :class="{'btn-dis': preDis}"
          @click.stop="_miniChange('left')"
        >
          <i class="iconfont iconzuo-"></i>
        </div>
        <div
          v-if="miniArrow"
          class="mini-next-btn"
          :class="{'btn-dis': nextDis}"
          @click.stop="_miniChange('right')"
        >
          <i class="iconfont iconyou-"></i>
        </div>
        <div class="mini-wrap-box" id="previewList">
          <div class="list-ul" id="dataListUl">
            <div
              class="list-li"
              :class="{'select-page': index === selectIndex}"
              v-for="(item, index) in dataList"
              :key="index"
              :title="item.resourceTitle"
              @click="_miniClick(index)"
            >
              <div v-if="!item.coverUrl" class="transcoding-box">
                <img src="../../assets/system-resource-processing.png" class="transcoding-image" alt="">
              </div>
              <img v-else :src="item.coverUrl" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { originUrl } from "config/constant";
import H5Video from "./h5video";
import { reqGetTopicResource } from "api/topic-classes";
import { localStorageUtil, sessionStorageUtil, debounce, formatDateTime, getFileSuffix } from 'utils/util';
export default {
  name: 'videoList',
  components: {
    H5Video
  },
  props: {
    resourceId: {
      type: [Number, String],
    },
    resourceItem: {
      type: Object,
    },
    resourceTitle: {
      type: String,
      default: ''
    },
    subResourceId: {
      type: [Number, String],
    },
    videoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    needStatistics: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      imgSrc:
        originUrl.indexOf("http://localhost") !== -1
          ? "http://mvr-learning.viewshare.net"
          : originUrl,
      loading: true,
      videoInfo: {},
      loading: true,
      dataList: [],
      selectIndex: 0,
      imageW: 119,
      miniArrow: false,
      resCode: 0,
    };
  },
  computed: {
    preDis() {
      return this.selectIndex > 0 ? false : true;
    },
    nextDis() {
      return this.selectIndex < this.dataList.length - 1 ? false : true;
    },
    title() {
      let str = this.resourceTitle;
      if(this.dataList[this.selectIndex]) {
        str = `${this.resourceTitle ? this.resourceTitle + '：' : ''}${this.dataList[this.selectIndex].resourceTitle}`;
      }
      return str;
    }
  },
  watch: {
    resourceId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.selectIndex = 0;
          this.dataList = [];
          this._getDataList();
        }
        
      }
    },
    videoList: {
      immediate: true,
      handler(val) {
        if(val && val.length) {
          this.selectIndex = 0;
          this.dataList = [...val];
          this._getDataList();
        }
        
      }
    },
    selectIndex: {
      immediate: true,
      handler(val) {
        if(this.dataList.length &&　val) {
          this._getVideoDetailData(this.dataList[val]);
        }
      }
    },
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function(el) {
        el.onmousedown = function(e) {
          let _class = $(e.target).attr('class');
          if(!_class) {
            return;
          }
          if(_class.indexOf('vs4-top') === -1 && _class.indexOf('title') === -1) {
            return;
          } 
          let moveEle = $("#vs4Preview"),
            x = 0,
            y = 0,
            nx = 0,
            ny = 0,
            nl = 0,
            nt = 0,
            l = 0,
            t = 0,
            ml = 0,
            mt = 0,
            isDown = false;
          //获取x坐标和y坐标
          x = e.clientX;
          y = e.clientY;
          //获取左部和顶部的偏移量
          l = moveEle.offset().left;
          t = moveEle.offset().top;

          ml = moveEle.css("marginLeft");
          ml = ml.replace("px", "");
          mt = moveEle.css("marginTop");
          mt = mt.replace("px", "");
          document.onmousemove = function(e) {
            //获取x和y
            nx = e.clientX;
            ny = e.clientY;
            //计算移动后的左偏移量和顶部的偏移量
            nl = nx - (x - l) - ml;
            nt = ny - (y - t) - mt;

            moveEle.css({ left: nl + "px", top: nt + "px" });
          };
          document.onmouseup = function(e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
   
    /**
    * 数据获取
    * **/
    _getDataList() {
      this.loading = true;
      if(this.videoList && this.videoList.length) {
        for(let i = 0; i < this.dataList.length; i++) {
          let x = this.dataList[i];
          if(this.subResourceId && x.resourceId === this.subResourceId) {
            this.selectIndex = i;
          }
        }
        if(!this.selectIndex) {
          this._getVideoDetailData(this.dataList[0]);
        }
        this.$nextTick(() => {
          let w = this.dataList.length * this.imageW;
          $("#dataListUl").css("width", w + "px");
          if(this.selectIndex) {
            this._miniClick(0);
          }
        });
        this.loading = false;
        return;
      }
      let obj = {
        subjectId: this.resourceItem.subjectId,
        editionId: this.resourceItem.editionId,
        volumeId: this.resourceItem.volumeId,
        topicClassesId: this.resourceId,
        purpose: 2, // 我的任务--学习资源--专题包
      };
      if(this.resourceItem.chapterOneId) {
        obj.chapterOneId = this.resourceItem.chapterOneId;
        if(this.resourceItem.chapterTwoId) {
          obj.chapterTwoId = this.resourceItem.chapterTwoId;
          if(this.resourceItem.chapterThreeId) {
            obj.chapterThreeId = this.resourceItem.chapterThreeId;
          }
        }
      }
      return reqGetTopicResource(obj).then(res => {
        this.resCode = res.code;
        if(res.code === 0) {
          this.dataList = res.data;
          for(let i = 0; i < this.dataList.length; i++) {
            let x = this.dataList[i];
            let cover_change = localStorageUtil.getItem('cover_change');
            if(x.coverUrl) {
              x.coverUrl = x.coverUrl + (cover_change ? '?stamp=' + cover_change : '');
            }
            if(this.subResourceId && x.resourceId === this.subResourceId) {
              this.selectIndex = i;
            }
          }
          if(!this.selectIndex && this.dataList.length) {
            this._getVideoDetailData(this.dataList[0]);
          }
          this.$nextTick(() => {
            let w_wrap = $("#previewList").width();
            let w = this.dataList.length * this.imageW;
            $("#dataListUl").css("width", w + "px");
            if(w - 15 > w_wrap) {
              this.miniArrow = true;
            }else {
              this.miniArrow = false;
            }
            if(this.selectIndex) {
              this._miniClick(0);
            }
          });
        }else {

        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.resCode = 999;
        console.log('err', err);
      });
    },

    /**
     * 资源--预览--vs4
     * @param {String} id: 请求的资源Id
     */
    _getVideoDetailData(data, isTrySee) {
      this._vs4Close('switch');
      this.videoInfo.loading = true;
      this.videoInfo.loading = false;

      let _coverUrl = "";
      if(data.coverUrl) {
        let i = data.coverUrl.indexOf(".net/") || val.coverUrl.indexOf(".cn/") || val.coverUrl.indexOf(".com/");
        if (i !== -1) {
          let str = "";
          if (data.coverUrl.indexOf(".net/") !== -1 || data.coverUrl.indexOf(".com/") !== -1) {
            str = data.coverUrl.substr(i + 4, data.coverUrl.length);
          } else if (data.coverUrl.indexOf(".cn/") !== -1) {
            str = data.coverUrl.substr(i + 3, data.coverUrl.length);
          }
          _coverUrl = str;
        } else {
          _coverUrl = `/${data.coverUrl}`;
        }
      }
      this.videoInfo = {
        loading: false,
        isTrailer: data.isTrailer,
        trailerDuration: data.isTrailer && data.trailerDuration ? data.trailerDuration : 0,
        resourceId: data.resourceId,
        videoUrl: `/teacher/resourceAuthentication/${data.resourceId}`,
        coverUrl: _coverUrl,
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "bearer " + Cookies.get("mvr_student_Token"),
        title: data.resourceTitle ? data.resourceTitle : data.fileName,
        hadLogo: data.hadLogo,
      };
      
      if(data.fileUrl && data.fileUrl.indexOf('.mp4') === data.fileUrl.length - 4 && data.fileUrl.indexOf('http') === 0) {
        this.videoInfo.videoUrl = data.fileUrl;
      }
      console.log("this.videoInfo", this.videoInfo);
    },

    
    /**
     * vs4关闭预览
     * **/
    _vs4Close(type = 'close') {
      this.$nextTick(() => {
        if(this.$refs.videoWrapper) {
          this.$refs.videoWrapper._videoPause();
        }
      });
      this.videoInfo = {
        loading: false,
        isTrailer: false,
        trailerDuration: 0,
        resourceId: "",
        videoUrl: "",
        coverUrl: "",
        enValue: "",
        zhValue: "",
        enAndzhValue: "",
        tValue: "",
        title: ""
      };
      if(type === 'close') {
        this.$emit("handleClose", 'list-video');
      }
    },

    /**
     * 下面缩略图展开折叠
     * **/
    _upDown() {
      this.upDown = !this.upDown;
      // $('#preListWrap').animate({ "height": this.upDown ? (this.imageW > 110 ? 100: 76) : 0 + "px" });
    },
    /**
     * 上一个下一个
     * **/
    _selectChange(flag) {
      // console.log(Pdf);
      if (flag === "left" && !this.preDis) {
        this.selectIndex > 0 && this.selectIndex--;
        this._setPosition("left", 1, true);
      } else if (flag === "right" && !this.nextDis) {
        this.selectIndex < this.pageCount - 1 && this.selectIndex++;
        this._setPosition("right", 1, true);
      }
    },
    /**
     * 下面缩略列表上一页下一页
     * **/
    _miniChange(flag) {
      if (flag === "left") {
        this._setPosition("left");
      } else {
        this._setPosition("right");
      }
    },
    /**
     * 下面缩略列表上点击某一个
     * **/
    _miniClick(index) {
      let deff = Math.abs(this.selectIndex - index);
      if (this.selectIndex > index) {
        this.selectIndex = index;
        this._setPosition("left", deff, true);
      } else {
        this.selectIndex = index;
        this._setPosition("right", deff, true);
      }
    },

    /**
     * 设置list宽度
     * **/
    _setListWidth() {
      
    },

    /**
     * @desc 设置缩略列表位置移动
     * @param type 上left 下right
     * @param num 每次移动的个数 默认5个
     * @param select 点击某一个 默认false
     * **/
    _setPosition(type, num = 5, select = false) {
      let isAnimate = true;
      if (
        this.lastClickTime &&
        new Date().getTime() - this.lastClickTime < 400
      ) {
        // animate的默认动画时间是400毫秒，如果连续点击的时间小于400毫秒，则此次左右滑动就无需动画了
        isAnimate = false;
      }
      this.lastClickTime = new Date().getTime();
      // if (this.switching) { // 上次缩略图的定位还没完成（因为animate是要时间执行的）
      //   return;
      // }
      let wrapW = $("#previewList").width(); // 放缩略图的盒子的宽度
      let dataListUl = $("#dataListUl");
      let allW = dataListUl.width(); // 所有缩略图的宽度
      let allML = parseInt(dataListUl.css("margin-left").replace("px", "")); // 缩略图的margin-left
      if (allW <= wrapW) {
        return;
      } // 如果所有缩略图的宽度还没有放缩略图的盒子宽的话 左右按钮都没用
      if (type === "left") {
        // 点击上一个---margin-left变大
        if (allML >= 0) {
          return;
        } // 如果margin-left大于0的话，说明没有必要再往右去了
        this.switching = true;
        let compute = allML + this.imageW * num; // 计算往右以后margin-left的宽度
        if (compute >= 0) {
          // 如果计算后的margin-left大于0，说明没有必要再往右去了
          compute = 0;
        }
        // 如果点击的是具体的某一个，所有右移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.selectIndex * this.imageW + 20;
          if (Math.abs(compute - wrapW) < l) {
            compute = -l + 20 + this.imageW;
          }
        }
       
        dataListUl.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {
            this.switching = false;
          }
        );
        return;
      }
      if (type === "right") {
        // 点击下一个---margin-left变小
        if (allW + allML < wrapW) {
          return;
        } // 如果所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
        this.switching = true;
        let compute = allML - this.imageW * num; // 计算往左以后margin-left的宽度
        if (allW + compute < wrapW) {
          // 如果计算后的所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
          compute = -(allW - wrapW);
        }
        // 如果点击的是具体的某一个，所有左移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.selectIndex * this.imageW + 20;
          if (Math.abs(compute) > l || Math.abs(compute + wrapW) > l) {
            compute = -l + 20;
          }
        }
        dataListUl.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {
            this.switching = false;
          }
        );
      }
    },
    /**
     * 键盘事件
     */
    _keydownEvent(ev) {
      if (ev.keyCode === 37 || ev.keyCode === 38) {
        // 上一张
        this._selectChange("left");
      } else if (ev.keyCode == 39 || ev.keyCode === 40) {
        // 下一张
        this._selectChange("right");
      }
    },

    handleScroll: debounce(function(e) {

      var direction = e.deltaY>0?'down':'up';
      this._selectChange(e.deltaY>0 ? 'right' : 'left');
    }, 50),
  },
  created() {
    window.addEventListener("keydown", this._keydownEvent);
  },
  destroyed() {
    this._vs4Close();
    window.removeEventListener("keydown", this._keydownEvent);
  }
};
</script>
<style lang="less" scoped>
.vs4-preview {
  width: 800px;
  height: 580px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -400px;
  margin-top: -250px;
  box-shadow: 0 0px 40px 0 rgba(0, 46, 54, 0.2);
  z-index: 9999;

  .vs4-top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #03B2B2;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    cursor: move;
    padding: 0 20px;

    .title {
      max-width: 70%;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 18px;
      float: left;
      color: #fff;
    }

    .iconclose {
      cursor: pointer;
      font-size: 20px;
      color: #fff;

      &:hover {
        text-shadow: 0 0 2px #fff;
      }
    }
  }

  .vs4-content {
    width: 100%;
    height: 450px;
    margin-top: 50px;
    background-color: #fff;
    .p-error {
      text-align: center;
      color: #03B2B2;
      font-size: 16px;
      padding-top: 220px;
    }
  }
  .vs4-bottom {
    width: 100%;
    height: 80px;
    background-color: #03B2B2;

    .current-page {
      float: left;
      color: #ffffff;
      font-size: 18px;
      max-width: 80px;
      height: 80px;
      line-height: 80px;
      padding: 0 10px;
      overflow: hidden;
    }

    .mini-list-box {
      float: right;
      width: calc(100% - 100px);
      height: 100%;
      padding: 0 20px;
      margin-right: 20px;
      position: relative;

      .mini-pre-btn, .mini-next-btn {
        height: 60px;
        width: 18px;
        color: #ccc;
        background: rgba(121, 121, 121, 0.3);
        cursor: pointer;
        position: absolute;
        top: 10px;
        z-index: 10;
        border-radius: 5px;

        &:hover {
          background: rgba(121, 121, 121, 0.6);
        }

        i.iconfont {
          font-size: 16px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #FFFFFF;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .mini-pre-btn {
        left: 0;
      }

      .mini-next-btn {
        right: 0;
      }

      .mini-wrap-box {
        width: calc(100% - 20px);
        margin: 0 10px;
        padding: 0 10px;
        height: 100%;
        overflow: hidden;

        .list-ul {
          height: 60px;
          margin-top: 10px;
          margin-left: 0;
          width: 999999px;

          .list-li {
            float: left;
            width: 104px;
            height: 60px;
            margin-right: 15px;
            cursor: pointer;
            border: 2px solid transparent;
            border-radius: 5px;
            background-color: #f5eded;
            overflow: hidden;
            position: relative;

            img {
              max-height: 100%;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }

            .pdf-thumbnail {
              width: 100%;
              height: 100%;
              cursor: pointer;

              div {
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
                user-select: none;
                cursor: pointer;
              }
            }
            .transcoding-image {
              width: 30px !important;
              height: 30px !important;
            }
          }

          .select-page {
            border: 2px solid #75C73B !important;
            transform: scale(1.1);
          }
        }
      }
    }
  }
}
</style>